import Service from "../service";
// import AuthService from "../AuthServ

const Police = {
    getPolice() {
        return Service.get('/police')
    },
    getPoliceByProvince(province_code) {
        return Service.get(`/PoliceStationByParam?province=${province_code}`)
    },
    getPoliceByHospital(hospital_code) {
        return Service.get(`/PoliceStationByParam?hospital=${hospital_code}`)
    },
    savePoliceStation(data) {
        return Service.post(`/savePoliceStation`,data)
    },
    getListPoliceStation(hospital_code) {
        return Service.get(`/listPoliceStation?hospital=${hospital_code}`)
    },
    getPoliceStationOption(hospital_code) {
        return Service.get(`/listPoliceStationOption?hospital=${hospital_code}`)
    },
    deletePoliceStation(data) {
        return Service.post(`/listPoliceStation`,data)
    }
};


export default Police;
